import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import TimeCardEntryForm from './TimeCardEntryForm';

class ManageTimeCardEntryPage extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.currentEntry) {
      if (this.props.currentEntry.id !== nextProps.currentEntry.id) {
        this.setState({
          currentEntry: Object.assign({}, nextProps.currentEntry),
        });
      }
    }
  }

  render() {
    const { currentEntry } = this.props;
    return (
      <div>
        <Row>
          <Col md={12}>
            <h1 className="text-center my-4">Manage Time Card Entry</h1>
          </Col>
        </Row>

        <TimeCardEntryForm currentEntry={currentEntry} />
      </div>
    );
  }
}

ManageTimeCardEntryPage.propTypes = {
  entry: PropTypes.object,
};

function getEntryById(entries, id) {
  const entry = entries.filter((entry) => entry.id === id);
  if (entry) return entry[0];
  return null;
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.match.params.id;
  const entryId = Number.parseInt(id, 10);

  let currentEntry = {
    id: '',
    cardId: '',
    entryDate: '',
    timeIn: '',
    timeOut: '',
    userId: '',
  };

  if (entryId && state.timeCardEntries.length > 0) {
    currentEntry = getEntryById(state.timeCardEntries, entryId);
  }

  return {
    currentEntry: currentEntry,
  };
}

export default connect(mapStateToProps, null)(ManageTimeCardEntryPage);



// WEBPACK FOOTER //
// ./src/components/timecard/ManageTimeCardEntryPage.js